export { default } from "./projectDetailsContainer";
